import React from "react";
import Math from "@/components/Math";

// Renders prose with $math$ and **bold** support.
export const Rich = ({ children, className = "" }) => {
  const parts = String(children ?? "").split(/(\*\*[^*]+\*\*)/g);
  return (
    <span className={className}>
      {parts.map((p, i) =>
        p.startsWith("**") && p.endsWith("**") && p.length > 4 ? (
          <strong key={i} className="text-zinc-50 font-semibold"><Math>{p.slice(2, -2)}</Math></strong>
        ) : (
          <Math key={i}>{p}</Math>
        )
      )}
    </span>
  );
};

export const Paragraphs = ({ items = [], className = "" }) => (
  <div className={`space-y-3 ${className}`}>
    {items.map((p, i) => (
      <p key={i} className="leading-relaxed"><Rich>{p}</Rich></p>
    ))}
  </div>
);
